import { render, staticRenderFns } from "./CreateHyxUser.vue?vue&type=template&id=38a43055&scoped=true"
import script from "./CreateHyxUser.vue?vue&type=script&lang=js"
export * from "./CreateHyxUser.vue?vue&type=script&lang=js"
import style0 from "./CreateHyxUser.vue?vue&type=style&index=0&id=38a43055&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a43055",
  null
  
)

export default component.exports